export default __webpack_public_path__ + "static/media/news-img.7c206bf1.png";